(ns motorsaif.web.lib.image-uploader
  (:require
   ["blueimp-load-image" :as load-image]
   [goog.object :as gobj]
   [motorsaif.log :as log]
   [motorsaif.shared.image-uploader :as siu]
   [promesa.core :as p]
   [re-frame.core :as rf :refer [dispatch]]
   [reagent.core :as r]))

(defn canvas-to-blob
  "Converts toBlob to a promise because the API
  only expects a callback and not assignable in a p/let"
  [canvas]
  (p/create (fn [resolve reject]
              (try
                (.toBlob canvas #(resolve %)
                         "image/jpeg"
                         0.90) ; hardcoded quality
                (catch js/Error e (reject e))))))

(defn- -prepare-form-data [{file-name :name
                            :keys [on-error file opts uuid *progress on-success
                                   *state *response] :as this}]
  (p/let [{:keys [full]} opts
          img (load-image file (clj->js (merge
                                         {:maxWidth 1000
                                          :maxHeight 1000
                                          :canvas true}
                                         full)))
          canvas (.-image img)
          blob (canvas-to-blob canvas)
          form-data (doto (js/FormData.)
                      (.append "file-name" file-name)
                      (.append "file" blob))]

    form-data))

(extend-type siu/ImageUpload
  siu/IImageUpload
  (prepare-form-data [this] (-prepare-form-data this)))

(defn create-image [file opts]
  (-> (p/let [{:keys [on-load on-success img-opts current-count]} opts
              meta (load-image/parseMetaData file)
              orientation (some-> meta
                                  (gobj/get "exif")
                                  (.get "Orientation"))

              img-preview (load-image file
                                      (clj->js (merge {:maxWidth 320
                                                       :maxHeight 320
                                                       :canvas true}
                                                      (:preview img-opts))))

              data-url (.toDataURL (.-image img-preview) "image/jpeg" 0.8)

              uuid (str (random-uuid))

              image-rec (siu/map->ImageUpload
                         {:uuid uuid
                          :preview data-url
                          :*response (r/atom nil)
                          :file file
                          :orientation orientation
                          :opts img-opts
                          :*progress (r/atom 0)
                          :on-success on-success
                          :size (.-size file)
                          :name (.-name file)
                          :*state (r/atom :new)})

              ret (assoc image-rec
                         :upload-fn #(siu/upload image-rec))]
        (on-load ret))
      (p/catch (fn [e]
                 (println "ERROR:" e)
                 (js/console.log e)))))

(defn handle-files
  "get-file-count returns how many images we currently have
  so we can compare it to file-limit"
  [{:keys [params file-limit get-file-count] :as opts
    :or {file-limit 20}} e]
  (let [input (.-target e)
        current-count (get-file-count)
        take-count (if (and file-limit get-file-count)
                     (- file-limit (get-file-count))
                     1)
        files (take take-count (array-seq (.-files input)))]

    (run! #(create-image % opts) files)))
